import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  acceptAnalytics,
  denyAnalytics,
  getAnalyticsConsent,
  initAnalyticsIfConsented,
} from '../utils/analyticsConsent';

/**
 * Banner mínimo de consentimento de analytics (PostHog).
 * Copy neutra — revisar com jurídico se necessário.
 */
export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initAnalyticsIfConsented();
    const consent = getAnalyticsConsent();
    if (!consent) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    acceptAnalytics();
    setVisible(false);
  };

  const handleDeny = () => {
    denyAnalytics();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Preferência de cookies analíticos"
      className="fixed bottom-0 inset-x-0 z-[100] p-4 md:p-6 pointer-events-none"
    >
      <div className="max-w-3xl mx-auto pointer-events-auto rounded-2xl bg-gray-900 text-white shadow-2xl border border-gray-700 p-4 md:p-5 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm text-gray-200 flex-1 leading-relaxed">
          Usamos analytics (PostHog) para melhorar o site. Essenciais continuam ativos.{' '}
          <Link
            to="/politica-de-privacidade#cookies"
            className="underline text-blue-300 hover:text-blue-200"
          >
            Privacidade
          </Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            type="button"
            onClick={handleDeny}
            className="px-4 py-2 rounded-full text-sm font-medium border border-gray-500 text-gray-200 hover:bg-gray-800 transition-colors"
          >
            Recusar
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-4 py-2 rounded-full text-sm font-semibold bg-[#0E76FF] text-white hover:bg-blue-600 transition-colors"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
